import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Input, Label } from "reactstrap";

/**
 * Zona para arrastrar o seleccionar archivos. Estilos en scss/dhn/_files.scss.
 *
 * Con react-dropzone se pasan `getRootProps` y `getInputProps` del hook;
 * sin ellos se usa un input nativo y `onChange` recibe el evento.
 *
 * <FileDropzone title="Adjuntar documentos" hint="PDF, JPG o PNG" multiple onChange={onFiles} />
 */
export default function FileDropzone({
  accept,
  className,
  compact,
  description,
  disabled,
  getInputProps,
  getRootProps,
  hint,
  icon,
  multiple,
  onChange,
  title,
}) {
  const classes = classnames("dhn-file-dropzone", className, {
    "is-compact": compact,
    "is-disabled": disabled,
  });
  const content = (
    <>
      <span className="dhn-file-dropzone__icon">
        <i className={classnames("fa", icon)} aria-hidden="true" />
      </span>
      <span className="dhn-file-dropzone__copy">
        <strong>{title}</strong>
        {description && <small>{description}</small>}
        {hint && <small className="dhn-file-dropzone__hint">{hint}</small>}
      </span>
    </>
  );

  if (getRootProps && getInputProps) {
    return (
      <div {...getRootProps({ className: classes })}>
        <input {...getInputProps()} />
        {content}
      </div>
    );
  }

  return (
    <Label className={classes}>
      <Input
        type="file"
        className="sr-only"
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={onChange}
      />
      {content}
    </Label>
  );
}

FileDropzone.propTypes = {
  accept: PropTypes.string,
  className: PropTypes.string,
  compact: PropTypes.bool,
  description: PropTypes.node,
  disabled: PropTypes.bool,
  getInputProps: PropTypes.func,
  getRootProps: PropTypes.func,
  hint: PropTypes.node,
  icon: PropTypes.string,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  title: PropTypes.node.isRequired,
};

FileDropzone.defaultProps = {
  accept: ".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png",
  compact: false,
  disabled: false,
  icon: "fa-cloud-upload",
  multiple: false,
};
